import { useIntl } from "react-intl";

import { HotelGalleryInline } from "@/features/hotels/components/hotel/HotelGalleryInline";
import { HotelName } from "@/features/hotels/components/hotels/HotelName";
import { HotelStars } from "@/features/hotels/components/hotels/HotelStars";
import type { HotelData } from "@/features/hotels/types/types";

type HotelDetailsCardProps = {
  hotel: HotelData;
  onImageTap: () => void;
};

export function HotelDetailsCard({ hotel, onImageTap }: HotelDetailsCardProps) {
  const intl = useIntl();

  return (
    <section className="section-card flex flex-col gap-3 overflow-hidden px-1 pt-1 pb-4">
      <HotelGalleryInline
        images={hotel.imagesUrls}
        onClick={onImageTap}
        hotelName={hotel.name}
      />
      <div className="px-3 pt-2 pb-0">
        <div className="mb-4 text-lg font-semibold">
          <HotelName name={hotel.name} />
        </div>
        <div className="flex items-center gap-2">
          {hotel?.stars > 0 && (
            <HotelStars showLabel={false} stars={hotel.stars} />
          )}
          {hotel.recommended && (
            <span className="rounded bg-surface-accent-softer px-1.5 py-1 text-sm font-semibold text-core-accent-700">
              {intl.formatMessage({
                defaultMessage: "Rahal's Choice",
                description: "Rahal's Choice badge label",
              })}
            </span>
          )}
        </div>
      </div>
      {/* TODO: common facilities section */}
    </section>
  );
}
